/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  VIEW_PROJECTS_DASHBOARD,
  PROJECTS_DASHBOARD_PATH,
} from 'domain/sales/projectsDashboard/useProjectsDashboardService';
import ProjectsDashboardList from 'domain/sales/projectsDashboard/List';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';

const useProjectsDashboardRoute = () => createRoute({ listRoute: PROJECTS_DASHBOARD_PATH });

const ProjectsDashboardRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useProjectsDashboardRoute();

  return (
    <ProtectedRouter basePath={PROJECTS_DASHBOARD_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={VIEW_PROJECTS_DASHBOARD}>
              <ProjectsDashboardList />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ProjectsDashboardRouter.getRouterPath = () => '/projects-dashboard/*';

export default ProjectsDashboardRouter;
